// 导出页面为PDF格式
import { all } from 'core-js/fn/promise'
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
export default {
  install(Vue, options) {
    Vue.prototype.getPdf = async function(title) {
    // 当点击下载pdf按钮不在页面顶部的时候会造成PDF样式不对
    // 首先回到页面顶部在下载PDF
      let top = document.getElementById('pdfDom')
      if (top != null) {
        top.scrollIntoView()
        top = null
      }
      var pdfDom = document.getElementById('pdfDom')
      var allheight = pdfDom.scrollHeight
      var pdf = new JsPDF('p', 'mm', 'a4') // A4纸，纵向
      var a4w = 210; var a4h = 297 // A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
      var imgHeight = Math.floor(a4h * pdfDom.scrollWidth / a4w) // 按A4显示比例换算一页图像的像素高度
      // 分成两次生成
      var part1_height = Math.ceil(Math.floor(allheight / imgHeight) / 2) * imgHeight// 前半部分的高度
      var part2_height = allheight - part1_height // 后半部分的高度
      if(allheight < 2 * imgHeight) {
        part1_height = allheight
        part2_height = 0
      }
      const canvas = await html2Canvas(document.querySelector('#pdfDom'), {
        height: part1_height,
        y: 0,
        scale: 1,
      })
      var renderedHeight = 0
      var ctx = canvas.getContext('2d')
      while (renderedHeight < canvas.height) {
        var page = document.createElement('canvas')
        page.width = canvas.width
        page.height = Math.min(imgHeight, canvas.height - renderedHeight)// 可能内容不足一页
        // 用getImageData剪裁指定区域，并画到前面创建的canvas对象中
        page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0)
        pdf.addImage(page.toDataURL('image/jpeg', 0.95), 'JPEG', 0, 0, a4w, Math.min(a4h, a4w * page.height / page.width)) // 添加图像到页面，保留10mm边距
        renderedHeight += imgHeight
        if (renderedHeight + imgHeight <= canvas.height) { pdf.addPage() }// 如果后面还有内容，添加一个空页
      }
      if(part2_height > 0) {
        pdf.addPage()
        const canvas2 = await html2Canvas(document.querySelector('#pdfDom'), {
          height: part2_height,
          y: part1_height,
          scale: 1, 
        });   
        var ctx = canvas2.getContext('2d')
        var renderedHeight = 0
        while (renderedHeight < canvas2.height) {
          var page = document.createElement('canvas')
          page.width = canvas2.width
          page.height = Math.min(imgHeight, canvas2.height - renderedHeight)// 可能内容不足一页
          // 用getImageData剪裁指定区域，并画到前面创建的canvas对象中
          page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas2.width, Math.min(imgHeight, canvas2.height - renderedHeight)), 0, 0)
          pdf.addImage(page.toDataURL('image/jpeg', 0.95), 'JPEG', 0, 0, a4w, Math.min(a4h, a4w * page.height / page.width)) // 添加图像到页面，保留10mm边距
          renderedHeight += imgHeight
          if (renderedHeight + imgHeight < canvas2.height) { pdf.addPage() }// 如果后面还有内容，添加一个空页
        }
      } 
      pdf.save(title + '.pdf')
      window.close()
    }
  }
}
